import { AuthorizationWrapper, Permission } from '@frontend/authorization';
import { ClassType } from '@frontend/common';
import { Spinner } from '@frontend/elements';
import React from 'react';
import { IconType } from 'react-icons';

import useHorizontalButtonGroup from './horizontal-button-group.controller';

const ID = 'horizontal-button-group';
export interface HorizontalButtonGroupButton {
    text?: React.ReactNode;
    disabled?: boolean;
    onClick?: (e: any) => void;
    icon?: IconType;
    type?: ClassType;
    isLoading?: boolean;
    hide?: boolean | (() => boolean);
    id?: string;
    requiredPermissions?: Permission[];
    buttonType?: 'submit' | 'button' | 'reset';
    enabled?: (obj: any[]) => boolean;
    className?: string;
    ariaLabel?: string;
    title?: string;
}

export interface HorizontalButtonGroupProps {
    buttons: HorizontalButtonGroupButton[];
    direction: 'left' | 'right';
    noFlex?: boolean;
}

export const HorizontalButtonGroup = (props: HorizontalButtonGroupProps) => {
    const viewProps = useHorizontalButtonGroup(props);
    const getContainerClassName = () => {
        let className = 'no-scrollbar gap-3';
        if (props.noFlex) {
            className = '';
        } else {
            className += ' flex';
        }

        if (props.direction === 'right') {
            className += ' justify-end overflow-y-scroll no-wrap';
        } else {
            className += ' justify-start flex-row-reverse overflow-y-scroll no-wrap';
        }

        return className;
    };

    const color = (button: HorizontalButtonGroupButton) => {
        switch (button.type) {
            case ClassType.PRIMARY:
                return 'btn-brand-primary';
            case ClassType.SECONDARY:
                return 'btn-brand-secondary';
            case ClassType.SUCCESS:
                return 'btn-status-success';
            case ClassType.WARNING:
                return 'btn-status-warning';
            case ClassType.DANGER:
                return 'btn-status-danger';
            case ClassType.INFO:
                return 'btn-status-info';
            default:
                return 'btn-brand-secondary';
        }
    };
    return (
        <div
            id={ID}
            className={getContainerClassName()}>
            {viewProps.buttons.map((button, i) => {
                const getButtonClassName = () => {
                    let className = '';
                    if (button.className) className = button.className;
                    else className = `btn ${color(button)}`;
                    return className;
                };
                const content = (
                    <button
                        id={button.id}
                        onClick={button.onClick}
                        className={getButtonClassName() + ' text-nowrap'}
                        key={i}
                        data-testid={button.id}
                        aria-label={button.ariaLabel}
                        title={button.title}
                        disabled={button.disabled}>
                        {button.isLoading ? (
                            <Spinner />
                        ) : (
                            <>
                                {button.icon && <button.icon />}
                                {button.text && <span className={`${button.icon ? 'ms-2' : ''}`}>{button.text}</span>}
                            </>
                        )}
                    </button>
                );

                return button.requiredPermissions ? (
                    <AuthorizationWrapper requiredPermissions={button.requiredPermissions}>{content}</AuthorizationWrapper>
                ) : (
                    content
                );
            })}
        </div>
    );
};
